import { render } from "./BlockHeader.vue?vue&type=template&id=3ec5c88c&scoped=true"
import script from "./BlockHeader.vue?vue&type=script&lang=js"
export * from "./BlockHeader.vue?vue&type=script&lang=js"

import "./BlockHeader.vue?vue&type=style&index=0&id=3ec5c88c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec5c88c"]])

export default __exports__